export function getIsMobileUa() {
  return /Mobi|Android|iPhone/i.test(navigator.userAgent);
}
